import React, { useEffect, Fragment, useContext } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  Col,
  Container,
  Form,
  FormGroup,
  Button,
  Row,
  Spinner,
  Card,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  verifyRecruiterInviteTokenRequest,
  resetVerifyRecruiterInviteToken,
} from "../../redux/public/verify_recruiter_invite_token/actions";
import { showToast } from "../../Components/Common/Toast";
import {
  acceptOrRejectInviteRequest,
  resetAcceptOrRejectInvite,
} from "../../redux/public/accept_or_reject_invite/actions";

import { COMPANY_LOGO } from "../../Constant";
import { AuthContext } from "../../Auth/AuthContext";

const AcceptInvite = () => {
  const dispatch = useDispatch();
  const { token } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const searchParams = new URLSearchParams(location.search);
  const isApprovalFlow = searchParams.get("flow") === "approval";
  const verifyRecruiterInviteTokenReducerData = useSelector(
    (state) => state.verifyRecruiterInviteTokenReducer
  );

  console.log("verifyRecruiterInviteTokenReducerData", verifyRecruiterInviteTokenReducerData);
  const acceptOrRejectInviteReducerData = useSelector(
    (state) => state.acceptOrRejectInviteReducer
  );

  useEffect(() => {
    if (token) {
      dispatch(verifyRecruiterInviteTokenRequest({ token }));
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (acceptOrRejectInviteReducerData.message) {
      if (acceptOrRejectInviteReducerData.status) {
        showToast("success", acceptOrRejectInviteReducerData.message);
        if (isApprovalFlow) {
          navigate("/job");
        } else if (acceptOrRejectInviteReducerData.invite_status) {
          navigate(
            user && user.isLoggedin
              ? "/job/recruiter/invite"
              : `/job/recruiter/auth/register/invite/${token}`
          );
        } else {
          navigate(user && user.isLoggedin ? "/job/recruiter/invite" : "/job");
        }
      } else {
        showToast("error", acceptOrRejectInviteReducerData.message);
      }
      dispatch(resetAcceptOrRejectInvite());
    }
  }, [acceptOrRejectInviteReducerData, dispatch, navigate, token, user, isApprovalFlow]);

  const handleCreateAccount = () => {
    navigate(`/job/recruiter/auth/register/invite/${token}`);
  };

  const handleApprovalDecision = (status) => {
    if (!token) return;
    dispatch(acceptOrRejectInviteRequest({ token, status }));
  };

  const isLoading = verifyRecruiterInviteTokenReducerData.isLoading;
  const status = verifyRecruiterInviteTokenReducerData.status;
  const isAlreadyAccepted = verifyRecruiterInviteTokenReducerData.isAlreadyAccepted;
  const message = verifyRecruiterInviteTokenReducerData.message;
  const inviteEmail = verifyRecruiterInviteTokenReducerData.inviteEmail;
  const companyName = verifyRecruiterInviteTokenReducerData.companyName;
  const source = verifyRecruiterInviteTokenReducerData.source;

  return (
    <Fragment>
      <Container>
        <Row className="justify-content-center mt-5">
          <Col xl="8" lg="10" md="12">
            <Card className="shadow-sm border-0">
              <CardBody className="p-4 text-center">
                <a href="/job" className="mb-4 d-inline-block">
                  <img
                    src={COMPANY_LOGO}
                    alt="Company Logo"
                    style={{ width: "150px" }}
                  />
                </a>
                <CardTitle tag="h4" className="mb-4 mt-4">
                  {isLoading
                    ? "Verifying…"
                    : isAlreadyAccepted
                    ? "Invitation Already Used"
                    : status
                    ? isApprovalFlow
                      ? "Recruiter Approval Request"
                      : "Create Your Account"
                    : "Invalid Invitation"}
                </CardTitle>
                <Form>
                  {isLoading ? (
                    <div className="text-center">
                      <Spinner color="primary" />
                      <p className="mt-2">Verifying invitation...</p>
                    </div>
                  ) : (
                    <>
                      {!status && (
                        <CardText className="text-danger text-center mb-4">
                          {message || "This invitation link is invalid or already used."}
                        </CardText>
                      )}
                      {status && isAlreadyAccepted && (
                        <CardText className="text-muted text-center mb-4">
                          This invitation link has already been used.
                        </CardText>
                      )}
                      {status && !isAlreadyAccepted && !isApprovalFlow && (
                        <>
                          <div className="text-start mx-auto mb-3" style={{ maxWidth: "420px" }}>
                            {inviteEmail && (
                              <CardText className="mb-1">
                                <strong>Invite Email:</strong> {inviteEmail}
                              </CardText>
                            )}
                            {companyName && (
                              <CardText className="mb-1">
                                <strong>Company:</strong> {companyName}
                              </CardText>
                            )}
                            {source && (
                              <CardText className="mb-0">
                                <strong>Source:</strong> {source}
                              </CardText>
                            )}
                          </div>
                          <CardText className="mb-4">
                            You have been invited to join as a recruiter. Click below to create your account.
                          </CardText>
                          <FormGroup className="d-flex justify-content-center">
                            <Button color="primary" onClick={handleCreateAccount}>
                              Create Account
                            </Button>
                          </FormGroup>
                        </>
                      )}
                      {status && !isAlreadyAccepted && isApprovalFlow && (
                        <>
                          <div className="text-start mx-auto mb-3" style={{ maxWidth: "420px" }}>
                            {inviteEmail && (
                              <CardText className="mb-1">
                                <strong>Recruiter Email:</strong> {inviteEmail}
                              </CardText>
                            )}
                            {companyName && (
                              <CardText className="mb-1">
                                <strong>Company:</strong> {companyName}
                              </CardText>
                            )}
                            {source && (
                              <CardText className="mb-0">
                                <strong>Source:</strong> {source}
                              </CardText>
                            )}
                          </div>
                          <CardText className="mb-4">
                            A recruiter registration is pending your approval. Please choose Accept or Reject.
                          </CardText>
                          <FormGroup className="d-flex justify-content-center gap-2">
                            <Button
                              color="success"
                              onClick={() => handleApprovalDecision("ACCEPTED")}
                              disabled={acceptOrRejectInviteReducerData.isLoading}
                            >
                              Accept
                            </Button>
                            <Button
                              color="danger"
                              onClick={() => handleApprovalDecision("REJECTED")}
                              disabled={acceptOrRejectInviteReducerData.isLoading}
                            >
                              Reject
                            </Button>
                          </FormGroup>
                        </>
                      )}
                    </>
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AcceptInvite;
